if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        const DEFAULT_TEXT =
          (this.submitButtonText &&
            this.submitButtonText.getAttribute &&
            this.submitButtonText.getAttribute("data-default-text")) ||
          (this.submitButtonText && this.submitButtonText.textContent) ||
          "ADD TO BAG";

        if (
          this.submitButtonText &&
          !this.submitButtonText.dataset.defaultText
        ) {
          this.submitButtonText.dataset.defaultText = DEFAULT_TEXT;
        }

        const setBtnText = (txt) => {
          if (!this.submitButtonText) return;
          this.submitButtonText.textContent = txt;
        };

        if (this.__addedToCartResetT) clearTimeout(this.__addedToCartResetT);

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".button-spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            this.submitButton.classList.add("is-success");
            setBtnText("ADDED! ✨");

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
              cartData: response,
            });

            const OPEN_DELAY = 500;

            const openCart = () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              }, OPEN_DELAY);
            };

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener("modalClosed", openCart, {
                once: true,
              });
              quickAddModal.hide(true);
            } else {
              openCart();
            }
          })
          .catch((e) => {
            console.error(e);
            this.error = true;
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.querySelector(".button-spinner").classList.add("hidden");

            if (!this.error) {
              this.submitButton.removeAttribute("aria-disabled");
              const backTo =
                (this.submitButtonText &&
                  this.submitButtonText.dataset.defaultText) ||
                "ADD TO BAG";
              this.__addedToCartResetT = setTimeout(() => {
                this.submitButton.classList.remove("is-success");
                setBtnText(backTo);
              }, 2500);
            } else {
              this.submitButton.classList.remove("is-success");
              const backTo =
                (this.submitButtonText &&
                  this.submitButtonText.dataset.defaultText) ||
                "ADD TO BAG";
              setBtnText(backTo);
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
